import FARE_VISUALIZATION_TYPES from "./fareVisualizationTypes";

const ROUTE_COLORS = {
    common: "#5baaff",
    platon: "#f56445",
    toll: "#6f1fd9",
};
Object.freeze(ROUTE_COLORS);

export default ROUTE_COLORS;

export const getRoadColorByClass = routeClass => {
    if ((routeClass & FARE_VISUALIZATION_TYPES.common) !== 0) {
        return ROUTE_COLORS.common;
    } 
    if ((routeClass & FARE_VISUALIZATION_TYPES.toll) !== 0) {
        return ROUTE_COLORS.toll;
    }
    if ((routeClass & FARE_VISUALIZATION_TYPES.platon) !== 0) {
        return ROUTE_COLORS.platon;
    }
    return "#878787";
};
